<app-uni-page
  [parent]="this"
  pageTitle="Inventory: Item Lookup"
  [bodyTemplate]="bodyTemplate"
  [footerTemplate]="footerTemplate"
></app-uni-page>

<ng-template #bodyTemplate>
  <div *ngIf="isPageReady" class="flex flex-col h-full">
    <!-- Toolbar -->
    <div class="qb-list-actions">
      <div class="flex items-center gap-4 flex-wrap">
        <div class="flex items-center gap-2">
          <label class="text-sm font-medium">Inventory ID:</label>
          <input
            pInputText
            class="w-40"
            [(ngModel)]="itemIdInput"
            (keydown.enter)="findById()"
            placeholder="scan or type"
            title="Inventory ID"
          />
          <button
            pButton
            type="button"
            class="p-button-raised p-button-sm"
            icon="pi pi-search"
            (click)="findById()"
          >
            <span>Find</span>
          </button>
        </div>

        <p-divider layout="vertical" class="mx-2 h-8" />

        <div class="flex items-center gap-2">
          <label class="text-sm font-medium">Search:</label>
          <input
            pInputText
            class="w-64"
            [(ngModel)]="searchText"
            (ngModelChange)="onSearchInputChanged()"
            placeholder="SKU / style / manufacturer"
            title="Free-text search"
          />
        </div>

        <p-divider layout="vertical" class="mx-2 h-8" />

        <div class="flex items-center gap-2">
          <label class="text-sm font-medium">Status:</label>
          <p-multiSelect
            [options]="allStatuses"
            [(ngModel)]="selectedStatuses"
            (ngModelChange)="onSelectedStatusesChange()"
            optionLabel="name"
            dataKey="id"
            placeholder="Any status"
            display="chip"
            class="w-80"
          ></p-multiSelect>
        </div>
      </div>
    </div>

    <!-- Body: results on the left, detail + log on the right -->
    <div class="grid grid-cols-12 gap-3 flex-1 min-h-0">
      <div class="col-span-7 flex flex-col min-h-0">
        <app-ag-grid [gridOptions]="resultsGridOptions" [rowData]="resultsRowData" class="flex-1 min-h-0"></app-ag-grid>
      </div>

      <div class="col-span-5 flex flex-col min-h-0 gap-3">
        <ng-container *ngIf="selectedItem; else noSelection">
          <!-- Detail summary card -->
          <div class="qb-detail-card qb-primary-tint p-3 shrink-0">
            <div class="font-semibold text-base mb-2 border-b pb-2 uppercase tracking-wide">
              Item Detail
            </div>
            <table class="qb-info-table w-full">
              <tr><td class="label">Inventory ID</td><td class="value">{{ selectedItem.id }}</td></tr>
              <tr><td class="label">Status</td><td class="value">{{ selectedItem.itemDetailStatus?.name }}</td></tr>
              <tr><td class="label">Bin</td><td class="value">{{ selectedItem.itemBin?.name || "—" }}</td></tr>
              <tr><td class="label">Last Scanned</td><td class="value">{{ selectedItem.lastScanTs | date:'short' }}</td></tr>
              <tr><td class="label">Account</td><td class="value">{{ selectedItem.account?.accountName || "—" }}</td></tr>
              <tr><td class="label">Manufacturer</td><td class="value">{{ selectedItem.product?.productType?.manufacturer?.name }}</td></tr>
              <tr><td class="label">Product Type</td><td class="value">{{ selectedItem.product?.productType?.description }}</td></tr>
              <tr><td class="label">Features</td><td class="value">{{ selectedItem.product?.featureChoicesExtract }}</td></tr>
            </table>
          </div>

          <!-- Audit log -->
          <div class="qb-detail-card flex-1 min-h-0 flex flex-col p-3">
            <div class="font-semibold text-base mb-2 border-b pb-2 uppercase tracking-wide shrink-0">
              Audit Log
            </div>
            <uni-item-detail-log-grid
              class="block flex-1 min-h-0"
              [itemDetailId]="selectedItem.id"
            ></uni-item-detail-log-grid>
          </div>
        </ng-container>

        <ng-template #noSelection>
          <div class="qb-detail-card p-3 text-sm text-gray-500">
            <span *ngIf="!hasSearched">Search by Inventory ID or by SKU / style / manufacturer to look up an item.</span>
            <span *ngIf="hasSearched">Select a row on the left to see details and audit history.</span>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #footerTemplate>
  <div class="left-buttons">
    <button pButton type="button" class="p-button-raised" icon="pi pi-arrow-left" (click)="goBack()">
      <span>Go Back</span>
    </button>
  </div>
</ng-template>
